import { Avatar } from '@mui/material';
import styles from './ProfileAvatar.module.css'
const ProfileAvatar = ({ style, className, onClick, src, children }) => {
    return (
        <Avatar
            className={style ? '' : className || styles.profile_img}
            style={{ cursor: 'pointer', borderRadius: '5px', ...style }}
            src={src}
            onClick={onClick}
            variant="square"
        >
            {children}
        </Avatar>
    )
}

export default ProfileAvatar